import { Component, OnInit, Input, ElementRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload';
import { CommonService } from '../../core/services/common.service';
import { map } from 'rxjs/operators/map';
import { environment } from '../../../environments/environment';
import { Http, Headers } from '@angular/http';
import { OcrService } from '../../core/services/ocr.service';

@Component({
  selector: 'app-ocr-document-uploader',
  templateUrl: './ocr-document-uploader.component.html',
  styleUrls: ['./ocr-document-uploader.component.css']
})
export class OcrDocumentUploaderComponent implements OnInit, OnChanges {

  @Input() docType: string;

  @Output() documentsUploaded = new EventEmitter();

  documentUploadForm: FormGroup;

  uploader: FileUploader = new FileUploader({ url: '' });

  showBackUrl = true;

  frontUrl: string = null;
  backUrl: string = null;

  maxFileSize: number = 5 * 1024;
  maxFileError: boolean = false;

  showFrontUrl = false;

  constructor(
    private fb: FormBuilder,
    private commonService: CommonService,
    private http: Http, private el: ElementRef) { }

  ngOnInit() {

    this.initForm();
    if (this.docType === 'pan') {
      this.showBackUrl = false;
    }

    this.ngOnChanges();




  }

  ngOnChanges() {
    this.setValidations();
  }

  initForm(): void {
    this.documentUploadForm = this.fb.group({
      'front_url': [''],
      'back_url': ['']
    });
  }

  resetForm(): void {
    this.documentUploadForm.reset();
    this.frontUrl = '';
    this.backUrl = '';
  }

  setValidations() {

    if (this.documentUploadForm) {
      if (this.docType === 'dl') {
        this.documentUploadForm.get('front_url').setValidators([Validators.required]);
        this.documentUploadForm.get('back_url').setValidators([Validators.required]);
      }

      if (this.docType === 'pan') {
        this.documentUploadForm.get('front_url').setValidators([Validators.required]);
        this.documentUploadForm.get('back_url').setValidators([]);
      }

      this.documentUploadForm.get('front_url').updateValueAndValidity();
      this.documentUploadForm.get('back_url').updateValueAndValidity();
    }

  }

  upload(type_of_file: string): void {



    // Locate the file element meant for the file upload.
    const inputEl: HTMLInputElement = this.el.nativeElement.querySelector('#' + type_of_file);

    // Get the total amount of files attached to the file input.
    const fileCount: number = inputEl.files.length;

    this.checkFileSize(inputEl, fileCount);

    if (!this.maxFileError) {

      // Create a new form data instance
      const formData: FormData = new FormData();

      // Check if the file count is greater than zero, to be sure a file was selected.
      if (fileCount > 0) { // a file was selected

        const files: any = inputEl.files;

        for (let i = 0; i < fileCount; i++) {

          formData.append('file_' + i, inputEl.files.item(i));
        }

        formData.append('type', type_of_file);

        const url: string = environment.client_url + 'ocr' + '/upload';

        const headers: Headers = new Headers({ Authorization: 'Basic ' + localStorage.getItem('token') });

        const options: any = { headers };

        // TODO:: move http to service

        this.http.post(url, formData).pipe(

          map((res: any) => res)).subscribe(
            (resonse) => {

              const data = resonse.json();
              this.frontUrl = data.front_url ? data.front_url : this.frontUrl;
              this.backUrl = data.back_url ? data.back_url : this.backUrl;

              if (this.frontUrl)
                this.documentUploadForm.get('front_url').setValue(this.frontUrl);

              if (this.backUrl)
                this.documentUploadForm.get('back_url').setValue(this.backUrl);

              this.commonService.notifications.success('File uploaded Successfully');

            },
            (error) => this.commonService.notifications.error('Unable to upload File')
          );
      }
    }
    this.maxFileError = false;
  }


  checkFileSize(inputEl: HTMLInputElement, fileCount: number): void {

    let fileSize: number = 0;

    for (let i = 0; i <= fileCount; i++) {

      if (inputEl.files[i]) {

        fileSize = inputEl.files[i].size / 1024;

        if (fileSize > this.maxFileSize) {
          this.maxFileError = true;
          this.commonService.notifications.error('Unable to upload!! File size must be less than 300KB');
          alert('Unable to upload!! File size must be less than 300KB');
        }

      }

    }
  }


  submitForm() {

    const data = {
      front_url: this.frontUrl,
      back_url: this.backUrl,
      docType: this.docType
    }

    this.documentsUploaded.emit(data);
  }



}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/ocr/ocr-document-uploader/ocr-document-uploader.component.ts